import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Lock, Clock, CheckCircle2 } from "lucide-react";
import { authAxios } from "@/context/AuthContext";
import { TUTORIALS, TIER_ORDER } from "@/data/growthContent";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function TutorialsPage() {
  const [tier, setTier] = useState(null);

  useEffect(() => {
    authAxios.get("/user/dashboard").then((r) => setTier(r.data.tier.name)).catch(console.error);
  }, []);

  if (tier === null) return <main className="max-w-4xl mx-auto px-4 py-24 text-center text-slate-400">Loading tutorials…</main>;
  const tierIdx = TIER_ORDER.indexOf(tier);

  return (
    <main data-testid="tutorials-page" className="max-w-5xl mx-auto px-4 sm:px-8 py-12">
      <p className="uppercase text-xs tracking-[0.2em] font-semibold text-emerald-600 mb-2 flex items-center gap-1.5"><GraduationCap className="w-4 h-4" /> Marketing Tutorials</p>
      <h1 className="font-heading text-4xl md:text-5xl tracking-tight mb-4">Tactics that move your tier.</h1>
      <p className="text-slate-600 max-w-2xl mb-12 leading-relaxed">Step-by-step playbooks for marketing your link — new tutorials unlock as you climb tiers.</p>

      {TIER_ORDER.map((t, ti) => {
        const tuts = TUTORIALS.filter((x) => x.tier === t);
        const locked = ti > tierIdx;
        if (!tuts.length) return null;
        return (
          <section key={t} className="mb-10">
            <h2 className="font-heading text-xl md:text-2xl tracking-tight mb-4 flex items-center gap-2">
              {t} tutorials {locked && <span className="flex items-center gap-1 text-xs font-semibold text-slate-500 bg-slate-100 px-3 py-1 rounded-full"><Lock className="w-3 h-3" /> Reach {t} to unlock</span>}
            </h2>
            {locked ? (
              <div className="space-y-3">
                {tuts.map((tut) => (
                  <div key={tut.id} data-testid={`tutorial-locked-${tut.id}`} className="flex items-center justify-between bg-white border border-slate-200 rounded-lg px-6 py-4 opacity-60">
                    <p className="font-medium text-sm">{tut.title}</p>
                    <Lock className="w-4 h-4 text-slate-400" />
                  </div>
                ))}
              </div>
            ) : (
              <Accordion type="single" collapsible className="bg-white border border-slate-200 rounded-lg px-6">
                {tuts.map((tut) => (
                  <AccordionItem key={tut.id} value={tut.id} data-testid={`tutorial-${tut.id}`}>
                    <AccordionTrigger className="text-sm font-medium text-left">
                      <span className="flex items-center gap-3">{tut.title}
                        <span className="flex items-center gap-1 text-xs text-slate-400 font-normal"><Clock className="w-3 h-3" /> {tut.minutes} min</span>
                      </span>
                    </AccordionTrigger>
                    <AccordionContent>
                      <ol className="space-y-3 pb-2">
                        {tut.steps.map((s) => (
                          <li key={s} className="flex gap-3 text-sm text-slate-600 leading-relaxed">
                            <CheckCircle2 className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" /> {s}
                          </li>
                        ))}
                      </ol>
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            )}
          </section>
        );
      })}
      <p className="text-sm text-slate-500">Climb faster: <Link to="/ads" className="text-emerald-700 font-medium">grab a ready-made ad →</Link></p>
    </main>
  );
}
